import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AccountCard from './AccountCard';
import { ContentContainer, InnerContain, FlexContainer } from './Styled';
import UserDetails from './UserDetails';
import AccountDetails from './AccountDetails';
import ValuesProvider from 'components/ValuesProvider';
import { PostPaidNotice } from '../App/Notices';

import {
  getCard,
  addCard,
  removeCard,
  updateUser,
  loadingCard,
  updateAccount
} from 'actions/session';

import { errorSet, errorClear } from 'actions/error';

export const Account = ({
  error,
  errorSet,
  errorClear,

  card,
  addCard,
  getCard,
  sourceId,
  removeCard,
  loadingCard,
  isLoadingCard,

  user,
  is_admin,
  account,
  updateUser,
  updateAccount,
  isLoadingDetails
}) => {

  return (
    <ContentContainer>
      <InnerContain>
        {
          account.is_postpaid
          ? <PostPaidNotice />
          : 
          <AccountCard
            card={card}
            error={error}
            addCard={addCard}
            getCard={getCard}
            errorSet={errorSet}
            sourceId={sourceId}
            errorClear={errorClear}
            userIsAdmin={is_admin}
            removeCard={removeCard}
            loadingCard={loadingCard}
            isLoadingCard={isLoadingCard}
          />
        }
        <FlexContainer>
          <ValuesProvider values={account}>
          <AccountDetails
            error={error}
            userIsAdmin={is_admin}
            updateAccount={updateAccount}
            isLoadingDetails={isLoadingDetails}
          />
          </ValuesProvider>
          <ValuesProvider values={user}>
            <UserDetails
              error={error}
              updateUser={updateUser}
              isLoadingDetails={isLoadingDetails}
            />
          </ValuesProvider>
        </FlexContainer>
      </InnerContain>
    </ContentContainer>
  );
};

const mapStateToProps = ({ session, loading, error }) => ({
  error: error,
  card: session.card,
  sourceId: session.stripe_source_id,
  isLoadingCard: loading.loadingCard,
  isLoadingDetails: loading.loadingDetails,
  account: session.account ? {
    name: session.account.name,
    is_postpaid: session.account.is_postpaid,
    address_line1: session.account.address_line1,
    address_line2: session.account.address_line2,
    address_suburb: session.account.address_suburb,
    address_state: session.account.address_state,
    address_postcode: session.account.address_postcode
  } : {},
  user: {
    last_name: session.last_name,
    first_name: session.first_name,
    email_address: session.email_address,
    mobile_number: session.mobile_number
  },
  is_admin: session.is_admin
});

const mapDispatchToProps = {
  getCard,
  addCard,
  errorSet,
  errorClear,
  removeCard,
  loadingCard,
  updateUser,
  updateAccount
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Account));
